import { styled } from 'styled-components';

const Dashboard = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

export default Dashboard;
